import React, { useEffect, useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { useOktaAuth } from '@okta/okta-react';
import LowerToolBar from '../LowerToolBar/LowerToolBar';
import BKlogo from './BKlogo';
import PLKlogo from './PLKlogo';
import THlogo from './THlogo';
import BrandSelector from './BrandSelector';
import { RootStateOrAny, useSelector } from 'react-redux';
import { setToken, authClient } from '../../utils/config.js';
import { Link, useHistory } from 'react-router-dom';
import { TOGGLE_PROFILE_OPTIONS_MODAL } from '../../redux/action-types/app-types';
import { actionListener } from '../../utils/helpers';
import ProfileOptions from '../ProfileOptions/ProfileOptions';
import { Divider } from '@material-ui/core';
import { useStyles } from './styles';
import store from '../../redux/store';
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import WarningBar from '../WarningBar/WarningBar';

const colors = {
  BK: {
    primary: '#d62300',
    secondary: '#fd8330',
  },
  PLK: {
    primary: '#ff7d00',
    secondary: '#e75200',
  },
  TH: {
    primary: '#c8102e',
    secondary: '#96071e',
  },
  default: {
    primary: '#ffffff',
    secondary: '#ffffff',
  },
};

export default function MenuAppBar(props: any) {
  const { authState, oktaAuth } = useOktaAuth();
  const classes = useStyles();
  const [auth, setAuth] = React.useState(false);
  const [showProfileOptionsModal, setShowProfileOptionsModal] = useState(false);
  const history = useHistory();
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );
  //ProfileOptions
  const { userInfo } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );
  ///////////////////
  useEffect(() => {
    const setAxiosAuthHeader = async () => {
      setAuth(!!authState?.isAuthenticated);
      setToken();
      if (selectedBrand != '') {
        localStorage.setItem('brand-id', selectedBrand);
      }
    };
    setAxiosAuthHeader();
  }, [authState, selectedBrand]);

  useEffect(() => {
    const unsubscribeOpenProfileOptionsModal = actionListener(
      store,
      TOGGLE_PROFILE_OPTIONS_MODAL,
      function (action) {
        setShowProfileOptionsModal(action.payload);
      },
    );

    return () => {
      unsubscribeOpenProfileOptionsModal();
    };
  }, [showProfileOptionsModal]);

  const handleLogout = async () => {
    await authClient.revokeAccessToken().catch((err) => {
      console.log(err);
    });
    await authClient.signOut().catch((err) => {
      console.log(err);
    });
    localStorage.clear();
    history.push("/");
  };

  let logoSelection = brand => {
    switch (brand) {
      case 'BK':
        return <BKlogo />;
      case 'PLK':
        return <PLKlogo />;
      case 'TH':
        return <THlogo />;
      default:
        return <BKlogo />;
    }
  };
  let logoMarkup = logoSelection(selectedBrand);
  const nameColor = history.location.pathname === '/login' ? 'black' : 'white';
  //ProfileOptions functionality
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    setShowProfileOptionsModal(true);
  };
  const handleClose = () => {
    setShowProfileOptionsModal(false);
    setAnchorEl(null);
  };
  const id = showProfileOptionsModal ? 'simple-popover' : undefined;
  ////////////////////////////////
  return (
    <div className={classes.root}>
      <AppBar position="fixed">
        <WarningBar />
        <Toolbar
          style={
            selectedBrand
              ? {
                backgroundColor: colors[selectedBrand].primary,
                minHeight: 60,
              }
              : { backgroundColor: colors['default'].primary, minHeight: 60 }
          }
        >
          <Link to="/restaurants" >
            <HomeRoundedIcon className={classes.homeIcon} />
          </Link>

          {auth && (
            <div className={classes.logo}>
              <div>{logoMarkup}</div>
              <div>
                <BrandSelector />
              </div>
            </div>
          )}
          {auth && (
            <ProfileOptions
              handleClick={handleClick}
              handleClose={handleClose}
              handleLogout={handleLogout}
              userInfo={userInfo}
              open={showProfileOptionsModal}
              anchorEl={anchorEl}
              id={id}
            />
          )}
        </Toolbar>
        <Divider
          variant="middle"
          style={{
            marginTop: 0,
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0,
            paddingLeft: 0,
            paddingRight: 0,
            height: 5,
            backgroundColor: selectedBrand
              ? colors[selectedBrand].secondary
              : colors['default'].secondary,
          }}
        />
        {auth && <LowerToolBar />}
      </AppBar>
    </div>
  );
}
